module.exports = __webpack_public_path__ + "static/media/icon-social-in.9cae88e2.svg";